import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { TriangleAlert } from "lucide-react"

/**
 * Marks a supplier that has warning notes. The callers decide whether to render it
 * (MC_NOTES on and a count above zero): a list row must not get an empty slot
 * otherwise.
 */
export function SupplierWarningBadge({
  count,
  className,
}: {
  count: number
  className?: string
}) {
  const { translate } = useTranslation()
  const label = translate("MC_NOTE_WARNING_BADGE_TOOLTIP", { n: count })
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            // Focusable, so a keyboard user reaches the tooltip text too.
            tabIndex={0}
            aria-label={label}
            className={cn("inline-flex text-attention", className)}
          >
            <TriangleAlert size={13} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
